import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function EmptyTasks() {
  return (
    <div className="empty-tasks">
      <FontAwesomeIcon icon={['fal', 'sticky-note']} />
      <p>You have no Urgent Tasks.</p>
    </div>
  );
}
